import { useEffect, useMemo } from "react";
import classes from "./Report.module.css";
import BoxWrapper from "../../../../../components/ui/boxWrapper";

function AllInvoiceRecon({ onTabClick, allinvoicerecondata, loading }) {
  useEffect(() => {
    onTabClick();
  }, [onTabClick]);

  const rows = useMemo(() => {
    if (loading) {
      return (
        <tr>
          <td colSpan={11} className={classes.loader}>
            Loading...
          </td>
        </tr>
      );
    }
    const invoiceData = allinvoicerecondata?.record?.allInvoiceRecon ?? [];

    if (!invoiceData.length) {
      return (
        <tr>
          <td colSpan={17} className={classes.noData}>
            No Data Found!
          </td>
        </tr>
      );
    }

    return invoiceData.map((invoice, index) => (
      <tr key={index}>
        <td style={{ color: "black" }}>{invoice.GSTIN}</td>
        <td style={{ color: "black" }}>{invoice.Vendor_Name}</td>
        <td style={{ color: "black" }}>{invoice.DOC_NUMBER}</td>
        <td style={{ color: "black" }}>{invoice.DATE}</td>
        <td style={{ color: "black" }}>{invoice.TYPE}</td>

        <td style={{ color: "black" }}>
          {Number(invoice.Taxable_Value_Books).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.CGST_Books).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.SGST_Books).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.IGST_Books).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.Cess_Books).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.Total_Amount_Books).toFixed(2)}
        </td>

        <td style={{ color: "black" }}>{invoice.books_itc}</td>
        <td style={{ color: "black" }}>{invoice.books_rcm}</td>
        <td style={{ color: "black" }}>
          {Number(invoice.Taxable_Value_GSTR6A).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.CGST_GSTR6A).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.SGST_GSTR6A).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.IGST_GSTR6A).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.Cess_GSTR6A).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.Total_Amount_Books_GSTR6A).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>{invoice.gst_itc}</td>
        <td style={{ color: "black" }}>{invoice.gst_rcm}</td>
        <td style={{ color: "black" }}>
          {Number(invoice.Taxable_Value_Diff).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.TaxValue_Diff).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.Total_Amount_Diff).toFixed(2)}
        </td>

        <td style={{ color: "black" }}>{invoice["Remarks 2"]}</td>
        <td style={{ color: "black" }}>{invoice.itc_status}</td>
        <td style={{ color: "black" }}>{invoice.rcm_status}</td>

        <td style={{ color: "black" }}>{invoice.Is_amended}</td>
      </tr>
    ));
  }, [allinvoicerecondata?.record?.allInvoiceRecon, loading]);
  return (
    <>
      <BoxWrapper
        searchInputPlaceholder="Search..."
        boxTitle="Reconciliation Status:  All Invoice Recon(s)"
      >
        <div className={classes.ResponsiveTable}>
          <table className={classes.missingInAccountTableCss}>
            <thead>
              <tr>
                <th rowSpan={2}>GSTIN</th>
                <th rowSpan={2} align="right">
                  VENDOR NAME
                </th>
                <th rowSpan={2} align="right">
                  DOC NUMBER
                </th>
                <th rowSpan={2} align="right">
                  DATE
                </th>
                <th rowSpan={2} align="right">
                  DOC TYPE
                </th>

                <th
                  style={{ background: "#ffcc66" }}
                  colSpan={8}
                  align="center"
                >
                  As per Books
                </th>
                <th
                  style={{ background: "#c6ffb3" }}
                  colSpan={8}
                  align="center"
                >
                  As per GSTR6A
                </th>
                <th style={{ background: "ORANGE" }} colSpan={3} align="center">
                  Difference
                </th>
                <th rowSpan={2} align="right">
                  REMARKS
                </th>
                <th rowSpan={2} align="right">
                  ITC STATUS
                </th>
                <th rowSpan={2} align="right">
                  RCM STATUS
                </th>
                <th rowSpan={2} align="right">
                  IS AMENDED
                </th>
              </tr>
              <tr>
                <th style={{ background: "#ffcc66" }} align="right">
                  TAXABLE VALUE
                </th>
                <th style={{ background: "#ffcc66" }} align="right">
                  CGST
                </th>
                <th style={{ background: "#ffcc66" }} align="right">
                  SGST
                </th>
                <th style={{ background: "#ffcc66" }} align="right">
                  IGST
                </th>
                <th style={{ background: "#ffcc66" }} align="right">
                  CESS
                </th>
                <th style={{ background: "#ffcc66" }} align="right">
                  TOTAL AMOUNT
                </th>
                <th style={{ background: "#ffcc66" }} align="right">
                  ITC
                </th>
                <th style={{ background: "#ffcc66" }} align="right">
                  RCM
                </th>

                <th style={{ background: "#c6ffb3" }} align="right">
                  TAXABLE VALUE
                </th>
                <th style={{ background: "#c6ffb3" }} align="right">
                  CGST
                </th>
                <th style={{ background: "#c6ffb3" }} align="right">
                  SGST
                </th>
                <th style={{ background: "#c6ffb3" }} align="right">
                  IGST
                </th>
                <th style={{ background: "#c6ffb3" }} align="right">
                  CESS
                </th>
                <th style={{ background: "#c6ffb3" }} align="right">
                  TOTAL AMOUNT
                </th>
                <th style={{ background: "#c6ffb3" }} align="right">
                  ITC
                </th>
                <th style={{ background: "#c6ffb3" }} align="right">
                  RCM
                </th>

                <th style={{ background: "ORANGE" }} align="right">
                  TAXABLE VALUE
                </th>
                <th style={{ background: "ORANGE" }} align="right">
                  TAX
                </th>
                <th style={{ background: "ORANGE" }} align="right">
                  TOTAL AMOUNT
                </th>
              </tr>
            </thead>

            <tbody>{rows}</tbody>
          </table>
        </div>
      </BoxWrapper>
    </>
  );
}

export default AllInvoiceRecon;
